import { render, staticRenderFns } from "./PatientTasksCard.vue?vue&type=template&id=749a48e0&scoped=true"
import script from "./PatientTasksCard.vue?vue&type=script&lang=js"
export * from "./PatientTasksCard.vue?vue&type=script&lang=js"
import style0 from "./PatientTasksCard.vue?vue&type=style&index=0&id=749a48e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749a48e0",
  null
  
)

export default component.exports